<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="copyright">
<p class="para"><a id="page_4"></a> </p>
<p class="para"> </p>
<p class="copy1">Published 2011—IMM Lifestyle Books, an imprint of Fox Chapel Publishing<br/><em><a href="http://www.foxchapelpublishing.com" target="_blank">www.foxchapelpublishing.com</a></em></p>
<p class="copy1">IMM Lifestyle Books are distributed in the UK by Grantham Book Service, Trent Road, Grantham, Lincolnshire, NG31 7XQ</p>
<p class="copy1">Copyright © 2011 Ian Cooke and Fox Chapel Publishing Company, Inc., 903 Square Street, Mount Joy, PA 17552.</p>
<p class="copy1">All rights reserved. No part of this publication may be reproduced, stored in a retrieval system or transmitted in any form or by any means, electronic, mechanical, photocopying, recording or otherwise, without the prior written permission of the publisher and copyright holders.</p>
<p class="copy1">Print ISBN 9781504800570<br/>eISBN 9781607659228</p>
<p class="copy1">We are always looking for talented authors. To submit an idea, please send a brief inquiry to <a href="mailto:acquisitions@foxchapelpublishing.com">acquisitions@foxchapelpublishing.com</a>.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?c73adf9e